import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

import { RtAddNewButtonVariant } from '../../button.types';
import { BaseButtonDirective } from './../../base-button';

@Component({
  selector: 'rt-add-new-button, a[rt-add-new-button]',
  templateUrl: './add-new-button.component.html',
  styleUrls: ['./../../styles/base.less', './add-new-button.component.less'],
  // eslint-disable-next-line
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddNewButtonComponent extends BaseButtonDirective {
  @Input() public variant: RtAddNewButtonVariant = 'rounded';
}
